import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useDragStyles = makeStyles(() => {
  return createStyles({
    draggable: {
      cursor: 'move',
      pointerEvents: 'all',
    },
  });
});

export default useDragStyles;
